<script>
import VFadeTransition from '@/components/VFadeTransition'

export default {
  name: 'ImageTransition',
  components: {
    VFadeTransition,
  },
  props: {
    image: {
      type: String,
      required: false,
      default: undefined
    },
    text: {
      type: String,
      required: false,
      default: '',
    },
    small: {
      type: Boolean,
      required: false,
      default: false,
    }
  },
  computed: {
    validatedText() {
      if (this.text) {
        return String(this.text)
      }
      return 'Involves Stage'
    }
  }
}
</script>

<template>
  <div
    :class="{ 'image-transition--small': small }"
    class="image-transition"
  >
    <VFadeTransition>
      <img
        v-if="image"
        :src="image"
        :class="{ 'image-transition__img--small': small }"
        class="image-transition__img"
        alt="client logo"
      />
    </VFadeTransition>
    <div
      v-if="!image"
      class="image-transition__text">{{ validatedText }}
    </div>
  </div>
</template>

<style scoped>
.image-transition {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: var(--space-24);
  min-height: 108px;
}

.image-transition--small {
  min-height: 56px;
}

.image-transition__img {
  max-width: 230px;
  max-height: 108px;
  border-radius: 4px;
}

.image-transition__img--small {
  max-width: 115px;
  max-height: 56px;
}

.image-transition__text {
  text-align: center;
  max-width: 230px;
  max-height: 100px;
  overflow: hidden;
  font-size: var(--space-24);
  font-weight: bold;
  color: var(--color-default--dark);
  text-shadow: 0px 1px 2px rgba(29, 46, 68, 0.25);
}
</style>
